import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import { Row } from 'react-bootstrap';
import CircledIcon from '../../../components/CircledIcon';
import Link from '../../../components/Link';

const LoginRecoveryTabContent = () => {
  const linksData = [
    {
      title: 'Change password',
      link: 'javascript:;',
    },
    {
      title: 'Change Security Questions',
      link: 'javascript:;',
    },
    {
      title: 'Change Authentication Mobile Phone',
      link: 'javascript:;',
    },
    {
      title: 'Reset Interactive Response (IVR) PIN',
      link: 'javascript:;',
    },
    {
      title: 'Reset Interactive Response (IVR) PIN',
      link: 'javascript:;',
    },
    {
      title: 'Register Mobile App',
      link: 'javascript:;',
    },
  ];
  return (
    <>
      <section className={'w-100 d-flex justify-content-between mt-7'}>
        <div className={'d-flex align-items-center'}>
          <CircledIcon variant={'icon-emphasized'} icon={light('lock-open')} />
          <h4 className={'ms-7 mb-0 text-sm-20-lg-32'}>
            Login & Recovery Links
          </h4>
        </div>
      </section>
      <Row className={'mt-5'}>
        <div className={'mt-7 mc-layout-2-col'} style={{ columnGap: '40px' }}>
          {linksData.map((linkItem, index) => (
            <div key={index}>
              <Link
                rightIcon={light('chevron-right')}
                isAlignAtEnd
                isBlue
                key={index}
                href={linkItem.link}
              >
                {linkItem.title}
              </Link>
            </div>
          ))}
        </div>
      </Row>
    </>
  );
};

export default LoginRecoveryTabContent;
